import {useEffect} from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import ReactDOM from 'react-dom'
//import leaflet button css
import './LeafletButton.css'
import Searchbar from "../searchbar/searchbar";

/**
 * Create search location button for the leaflet map
 * @param props
 * @returns {*}
 */
const createLocationButton = (props) => {

    const ControlLocationButton = L.Control.extend({
        onAdd: (map) => {

            //Create the location button link
            const MyLocationButtonLink = L.DomUtil.create("a", "location-button");

            //Load the base location icon
            const LoadBaseIcon = () => {
                if (props.icon){
                    MyLocationButtonLink.innerHTML = `<i class="${props.icon}"></i>`
                } else {
                    MyLocationButtonLink.innerHTML = "locate"
                }
            }

            //Load the loader icon
            const LoadLoaderIcon = () => {
                if (props.iconLoader){
                    MyLocationButtonLink.innerHTML = `<i class="${props.iconLoader}"></i>`
                } else {
                    MyLocationButtonLink.innerHTML = "loading"
                }
            }

            //Init Base location icon
            LoadBaseIcon();

            L.DomEvent.on(MyLocationButtonLink,'click',() => {

                //Call function from the plugin location-notification if activated
                if (typeof window.openNotification !== "undefined"){
                    window.openNotification(3000)
                }
                //Load loader icon
                LoadLoaderIcon();

                map.locate().on('locationfound',(e) => {
                    map.panTo(e.latlng);

                    //Reset base icon
                    LoadBaseIcon()
                })

                map.locate().on('locationerror',(e) => {
                    //Reset base icon
                    LoadBaseIcon()
                })

            })

            return MyLocationButtonLink;
        }
    });
    return new ControlLocationButton({ position: "topleft" });
}

/**
 * Add the location button on the leaflet map
 * @param props
 * @returns {null}
 * @constructor
 */
const LocationButton = (props) => {
    const map = useMap();
    useEffect(() => {
        //Get created LocationButton
        const control = createLocationButton(props);

        //Add button to the map
        control.addTo(map);

        //Remove button on unmount to avoid duplication
        return function cleanup() {
            control._container.remove()
        }
    })

    return null;
}

export default LocationButton;